import { render } from "./IconElectraFrameStyle.vue?vue&type=template&id=092f0595"
import script from "./IconElectraFrameStyle.vue?vue&type=script&lang=js"
export * from "./IconElectraFrameStyle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__